/**
 * Dependencies
 */
import { cloneDeep } from 'lodash'

/**
 * State Definition
 *
 * @type {Object}
 */
const state = {
    data: {},
    users: [],
    outbound_invitations: {
        data: [],
        meta: {}
    },
    inbound_invitations: {
        data: [],
        meta: {}
    }
}

/**
 * Return a state copy
 *
 * @return {Object}
 */
export const getState = () => {
    return cloneDeep(state)
}

export default getState()



// WEBPACK FOOTER //
// ./src/state/modules/company/state.js